import { Exercise } from './exercise.model';
import { Guid } from '@fitscovery/common/types';
import { Partner } from '@fitscovery/partner/data-access';

export class BaseResponse {
    errors: string[];
    succeeded: boolean;
}

export class WorkoutResponse extends BaseResponse {
    request: any;
    data: Workout[];
}

export class Workout {
    id: string;
    title: string;
    description: string;
    partnerId: Guid;
    mediaUrl?: string;
    exercises: Exercise[];
    isForMembersOnly: boolean;
    isDisplayed: boolean;
    isArchived: boolean;
    partner: Partner;
    isAssigned: boolean;
}
